<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { RouterView } from 'vue-router'
import { PLayout } from '@previo/design-system'
import { Color } from '@previo/codebooks'
import { useFeatureFlags } from '@previo/feature-flags'

onBeforeMount(async () => {
  await useFeatureFlags().waitForInit()
})
</script>

<template>
  <p-layout :color="Color.GREY_100">
    <div class="p-safe-area-top">
      <router-view />
    </div>
  </p-layout>
</template>
